// Error response type for 302 endpoints
export type ErrorResponse = {
  error?: {
    err_code: number;
    [key: `message${string}`]: string;
    type: string;
  };
};

export const getMessage = (error: unknown) => {
  if (typeof error !== "object" || error === null) {
    return null;
  }
  const messageKey = {
    "zh-CN": "message_cn",
    "ja-JP": "message_jp",
    "en-US": "message",
  };
  // 获取当前网页的 URL
  const currentUrl = window.location.href;

  // 创建 URL 对象
  const url = new URL(currentUrl);
  // 获取查询参数
  const params = new URLSearchParams(url.search);

  // 示例：获取特定参数的值
  const paramValue = params.get("locale");

  const keys = Object.keys(messageKey);

  const key = (keys.find((key) => key === paramValue) ?? "en") as keyof typeof messageKey;

  const messageKeyInUse = messageKey[key];

  let result: string | null = null;
  try {
    result = (error as Record<string, string>)[messageKeyInUse];
  } catch {
    return result;
  }
  return result;
};
